import { ConfigProvider, message } from 'antd';
import 'antd/dist/antd.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Application from './Application';
import './index.css';
import store from './store/configureStore';
// import moment from 'moment';
// import 'moment/locale/zh-cn'
// import 'dayjs/locale/zh-cn'
// moment.locale('zh-cn')
import zh_CN from 'antd/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import PubSub from 'pubsub-js';
import { useEffect, useState } from 'react';
import memoryUtils from './utils/memoryUtils';
import storageUtils from './utils/storageUtils';

message.config({
  top: 300,
});

const user = storageUtils.getUser();

memoryUtils.user = user;
const Index = (props) => {
  const { config } = window;
  const [Theme, setTheme] = useState(config.theme);
  const ThemeRef = useState(Theme);
  ThemeRef.current = Theme;
  useEffect(() => {
    PubSub.subscribe('theme', (theme, data) => {
      // console.log('themezhh33333',data);
      setTheme(data);
      setTimeout(() => {
        config.theme = ThemeRef.current;
        // window.location.reload();
      }, 0);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ThemeRef.current, user]);
  return (
    <Provider store={store} theme={ThemeRef.current}>
      <ConfigProvider locale={zh_CN}>
        <Application config={window.config} theme={ThemeRef.current} />
      </ConfigProvider>
    </Provider>
  );
};

const root = createRoot(document.getElementById('root'));
root.render(<Index />);
